import apiClient from "./api/client";
import ENDPOINTS from "./api/endpoints";

export const stockService = {
  /** ------------------------------------------
   *  POST - Add Stock (Purchase)
   *  ----------------------------------------*/
  addStock: async (payload) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.STOCK.PURCHASE,
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Failed to add stock:", error);
      throw error;
    }
  },

  /** ------------------------------------------
   *  POST - Deduct Stock
   *  ----------------------------------------*/
  deductStock: async (payload) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.STOCK.DEDUCT,
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Failed to deduct stock:", error);
      throw error;
    }
  },

  /** ------------------------------------------
   *  POST - Consume Stock (Recipe Billing)
   *  ----------------------------------------*/
  consumeStock: async (billId, payload) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.STOCK.CONSUME(billId),
        payload
      );

      return response.data;
    } catch (error) {
      console.error(`Failed to consume stock for bill ${billId}:`, error);
      throw error;
    }
  },

  /** ------------------------------------------
   *  GET - Stock Update History
   *  ----------------------------------------*/
  getUpdates: async (filters = {}) => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.STOCK.UPDATES,
        { params: filters }
      );

      // backend returns array
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Failed to fetch stock update history:", error);
      throw error;
    }
  },
};

export default stockService;
